module.exports = {
	"ugc_where_validate": {
		"type": "validation",
		"dependencies": {
			"required": "location",
			"fallback": "ugc_where"
		},
		"question": "Were they from <%= location %>?",
		"options": {
			"yes": {
				"label": "Yes",
				"action": "ugc_dob"
			},
			"no": {
				"label": "No",
				"action": "ugc_where"
			},
			"skip": {
				"label": "Not Sure",
				"action": "ugc_dob"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/Questionnaire/data/validation.json
// module id = 1695
// module chunks = 0